import { faSave, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import NumberFormat from 'react-number-format';
import { Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import { createExchangeRate } from '../../../../helpers/api/currency';
import { SUCCESS_RESPONSE } from '../../../../helpers/codeResponses/codes';
import { formatAmountForBackend } from '../../../../helpers/currencyConversion';
import handleErrorMessage from '../../../../helpers/errors/handleErrorMessage';
import ButtonIcon from '../../../common/ButtonIcon';
import Flex from '../../../common/Flex';
import { Toast } from '../../../UI/toast/Toast';

const CreateExhangeRateModal = ({ isOpen, setIsOpen, exchangeRate, currency = { name: '', iso: '', id: null }, mutate = () => { } }) => {

    const toggle = () => setIsOpen(!isOpen);

    const [val, setVal] = useState(0);
    const [submitting, setSubmitting] = useState(false);

    const closeBtn = <>
        <Button className="close font-weight-normal bg-transparent border-0 shadow-none" onClick={toggle}>
            &times;
        </Button>
    </>

    const save = async () => {
        setSubmitting(true);
        createExchangeRate({ currency: currency.id, exchangeRate: { value: formatAmountForBackend(val) } })
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ type: 'success', title: 'Tasa de cambio creada exitosamente.' });
                    mutate();
                    toggle();
                    setVal(0);
                }
            })
            .catch(error=>handleErrorMessage(error))
            .finally(() => setSubmitting(false));

    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered modalClassName="theme-modal">
            <form>
                <ModalHeader toggle={toggle} tag="div" className="px-card bg-light border-0 flex-between-center" close={closeBtn}>
                    <h5 className='mb-0'>{exchangeRate ? 'Edición de tasa de cambio' : 'Registro de tasa de cambio'}</h5>
                </ModalHeader>
                <ModalBody>
                    <Row form>
                        <Col tag={FormGroup}>
                            <Label>Moneda a convertir</Label>
                            <Label className='form-control'>
                                {currency?.iso} | {currency?.name}
                            </Label>
                        </Col>
                    </Row>

                    <Row form>
                        <Col tag={FormGroup}>
                            <Label>Tasa de cambio al día por <b>$ 1</b></Label>
                            <NumberFormat placeholder="Ingrese la tasa de cambio actualizada al día." prefix={`${currency?.iso} `} onValueChange={({ value }) => setVal(value)} value={val} thousandSeparator decimalScale={2} fixedDecimalScale className='form-control' />
                            {!val && <span className='text-danger fs--1 mt-2'>El campo es obligatorio.</span>}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Flex align='center' justify='end'>
                        <ButtonIcon icon={faUndo} onClick={toggle} color='falcon-default' size='md' className='px-5 mr-2' transform="down-1 shrink-4" ><span>Volver</span></ButtonIcon>
                        <Button color='primary' onClick={save} size='md' disabled={submitting || !val} className='px-5 mr-2' transform="down-1 shrink-4" >
                            {!submitting ? <FontAwesomeIcon icon={faSave} className='mr-2' /> : <Spinner size='sm' className='mr-2' />}
                            <span>Registrar tasa de cambio</span>
                        </Button>
                    </Flex>
                </ModalFooter>
            </form>
        </Modal>
    )
}

export default CreateExhangeRateModal;